let credentials = {
    geoserver: {
        headers: {
            Authorization: "Basic " + btoa("admin:geoserver")
        }
    }
};

function getCredentials() {
    return credentials;
}

module.exports = {
    credentials: credentials,
    getCredentials: getCredentials
};